import { LiveData } from '@assetmark/ui-kit/dist/utils/live-data.utils';
import { ArrayUtils } from '@assetmark/ui-kit/dist/utils/array.utils';
import { ObjectUtils } from '@assetmark/ui-kit/dist/utils/object.utils';
import { RemoteDataUtils } from '@assetmark/ui-kit/dist/utils/remote-data.utils';
import memoize from '@devexperts/utils/dist/function/memoize';
import { rights } from 'fp-ts/lib/Array';
import { Either, left, right } from 'fp-ts/lib/Either';
import { fromNullable } from 'fp-ts/lib/Option';
import { API_VERSION } from '../constants/api.constant';
import { UserService } from '../lib/user-api/user.service';
import { TRole, TUser } from '../models/user.model';
import { User } from '../lib/model/User';
import { Role } from '../lib/model/Role';

export namespace UserApi {
	export const getUser = memoize(
		(): LiveData<TUser> =>
			UserService.apiUserV1Get(API_VERSION)
				.chainRD(value => RemoteDataUtils.fromEither(parseUser(value)))
				.shareReplay(1),
	);
}

const parseUser = (user: User): Either<Error, TUser> => {
	if (!ObjectUtils.isNotNullable(user)) {
		return left(new Error('User is not found: '));
	}

	return right({
		defaultRole: fromNullable(user.defaultRole),
		isImpersonated: fromNullable(user.isImpersonated),
		roles: ObjectUtils.isNotNullable(user.roles) ? rights(user.roles.map(parseRole)) : ArrayUtils.empty,
		userID: fromNullable(user.userID),
		firstName: fromNullable(user.firstName),
		lastName: fromNullable(user.lastName),
		middleName: fromNullable(user.middleName),
		preferredName: fromNullable(user.preferredName),
	});
};

const parseRole = (role: Role): Either<Error, TRole> => {
	if (!ObjectUtils.isNotNullable(role)) {
		return left(new Error('Role is not found: '));
	}

	return right({
		aplId: fromNullable(role.aplId),
		roleName: fromNullable(role.roleName),
		roleType: fromNullable(role.roleType),
		channelType: fromNullable(role.channelType),
		siebelId: fromNullable(role.siebelId),
		isActive: fromNullable(role.isActive),
		pcStatus: fromNullable(role.pcStatus),
	});
};
